interface Props {
  onRetry: () => void;
}

/** Shared "couldn't load the employee list" retry banner — swapped in for
 * EmployeeSelect by both AttendanceActionModal and LeaveRequestModal when
 * useEmployeeList's self-fetch fails. */
export default function EmployeeLoadErrorBanner({ onRetry }: Props) {
  return (
    <div className="flex items-center justify-between gap-2 mt-1 px-3 py-2 bg-destructive/5 border border-destructive/30 rounded-xl">
      <p className="text-xs text-destructive font-inter">Couldn't load the employee list.</p>
      <button type="button" onClick={onRetry} className="text-xs font-medium text-destructive underline shrink-0">
        Retry
      </button>
    </div>
  );
}
